/**
 * Scroll to the top of the page.
 */
export const scrollToVisible = (
  parentElement?: HTMLElement | null,
  childElement?: HTMLElement | null,
  options: { paddingTop?: number } = {},
): void => {
  const { paddingTop = 0 } = options;
  if (!parentElement || !childElement) return;

  const { offsetTop: childOffsetTop, offsetHeight: childOffsetHeight } =
    childElement;
  const { scrollTop: parentScrollTop, offsetHeight: parentOffsetHeight } =
    parentElement;

  const childOffsetBottom = childOffsetTop + childOffsetHeight;
  const parentOffsetBottom = parentScrollTop + parentOffsetHeight;

  let scrollDistance = 0;

  if (childOffsetTop < parentScrollTop) {
    // Off the top of the view (need to scroll up)
    scrollDistance = childOffsetTop - parentScrollTop - paddingTop;
  }
  if (childOffsetBottom > parentOffsetBottom) {
    // Off the bottom of the view (need to scroll down)
    scrollDistance = childOffsetBottom - parentOffsetBottom;
  }

  parentElement.scrollBy({ top: scrollDistance });
};

/**
 * Check if the child element is visible in the parent element.
 */
export const isVisible = (
  parentScrollTop: number,
  parentOffsetHeight: number,
  childOffsetTop: number,
  childOffsetHeight: number,
): boolean => {
  if (
    childOffsetTop >= parentScrollTop &&
    childOffsetTop + childOffsetHeight <= parentScrollTop + parentOffsetHeight
  ) {
    return true;
  }

  return false;
};

/**
 * Check if the child element is visible in the parent element.
 */
export const isVisibleInParent = (
  parentElement?: HTMLElement | null,
  childElement?: HTMLElement | null,
): boolean => {
  if (!parentElement || !childElement) return false;

  const { offsetTop: childOffsetTop, offsetHeight: childOffsetHeight } =
    childElement;
  const { scrollTop: parentScrollTop, offsetHeight: parentOffsetHeight } =
    parentElement;

  return isVisible(
    parentScrollTop,
    parentOffsetHeight,
    childOffsetTop,
    childOffsetHeight,
  );
};
